/**
 * `results` FeatureModule — Comptes-rendus (SIL/LIS compte-rendu emission + diffusion).
 *
 * Surfaces (all under the authenticated AppShell; the router wraps each route in ProtectedRoute +
 * ErrorBoundary using requiredCapabilities):
 *   - /resultats                              — the console (by-id lookup + emission entry + recents)
 *   - /resultats/comptes-rendus/:id           — render/preview + diffusion board + comptoir print
 *   - /resultats/demandes/:id/emettre         — emission from a validated demande
 *
 * Capabilities are the server's exact keys (server/src/modules/results/routes.js). The module gates
 * on results.compterendu.read (the minimum to reach any surface); finer mutating actions (create /
 * print / canal.release) are gated per-control via useCan AND re-checked server-side every request.
 */
import type { FeatureModule } from "@/app";
import { ResultsConsolePage } from "./ResultsConsolePage";
import { CompteRenduPage } from "./CompteRenduPage";
import { EmissionPage } from "./EmissionPage";
import { RecallPage } from "./RecallPage";
import { RESULTS_CAPS } from "./caps";
import { registerResultsMessages } from "./i18n";

const resultsModule: FeatureModule = {
  id: "results",
  title: "Comptes-rendus",
  requiredCapabilities: [RESULTS_CAPS.read],
  routes: [
    { path: "/resultats", element: <ResultsConsolePage /> },
    { path: "/resultats/comptes-rendus/:id", element: <CompteRenduPage /> },
    { path: "/resultats/demandes/:id/emettre", element: <EmissionPage /> },
    // NOVA-054 — the comptoir desk-recall worklist (D-24).
    { path: "/resultats/rappels", element: <RecallPage /> },
  ],
  nav: [
    {
      id: "results",
      path: "/resultats",
      label: "nav.results",
      icon: "▦",
      order: 50,
      section: "nav.section.production",
      requiredCapabilities: [RESULTS_CAPS.read],
    },
    {
      id: "results-recall",
      path: "/resultats/rappels",
      label: "nav.results.recall",
      icon: "↺",
      order: 51,
      section: "nav.section.production",
      requiredCapabilities: [RESULTS_CAPS.recall],
    },
  ],
  onRegister() {
    registerResultsMessages();
  },
};

export default resultsModule;
